module.exports = __webpack_public_path__ + "media/customizations/valencia/logo-new-ea8215a5093dd69490f24baa9ebda9ee.png";